import React, { useEffect, useMemo, useState } from "react";
import { Button } from "@mui/material";
import Tab from "../../components/Tab/Tab";
import PendingContent from "./PendingContent";
import ActiveVouchersContent from "./ActiveVouchersContent";
import ExpiredRedeemedContent from "./ExpiredRedeemedContent";
import VoucherItem from "./VoucherItem";
import SelectDropdown from "../../components/Form/SelectDropdown";
import {
  useForm,
  Controller,
  FormProvider,
  useFieldArray,
} from "react-hook-form";
import TextInput from "../../components/Form/TextInput";
import RadioInput from "../../components/Form/RadioInput";
import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import { BodyVoucher, CoeVoucher, PARFVoucher } from "./UserData";
import VoucherCard from "./VoucherCard";
import { ReactComponent as BackIcon } from "../../images/back.svg";
import CustomSlider from "../../components/Slider/CustomSlider";
import axios from "../../axios/axios";
import moment from "moment";

const FlooringVoucherFormModal = (props) => {
  const {
    onSubmit,
    customerOptions,
    RedemptionsRule,
    handleOptionChange,
    selectedOption,
    selectedItem,
    selectedFormIndex,
    formValues,
    setFormCurrentValues,
    vouchers,
    isEdit,
    flooringRateStatus
  } = props;

  // const methods = useForm({
  //     defaultValues: formValues,
  // });
  const methods = useForm({
    defaultValues: useMemo(() => {
      console.log("FORM VALUE CHANGEd", formValues);
      return formValues;
    }, [formValues]),
  });

  const {
    control,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    register,
    setValue,
    reset,
    trigger,
  } = methods;

  useEffect(() => {
    console.log("Reset");
    reset(formValues);
  }, [formValues]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "vouchers",
  });

  useEffect(() => {
    console.log("FIELDS", getValues());
    //append({ vouchers: formValues?.vouchers })
  }, [formValues]);

  useEffect(() => {
    setFormCurrentValues(watch("vouchers"));
  }, [watch("vouchers")]);

  console.log(
    "WATCH",
    watch(`vouchers.[${0}]`),
    vouchers[selectedItem]?.isDisabled
  );

  return (
    selectedFormIndex !== undefined && (
      <>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {fields?.map(
              (item, index) =>
                selectedFormIndex == index && (
                  <div
                    style={{
                      pointerEvents: vouchers[selectedItem]?.isDisabled
                        ? "none"
                        : "auto",
                    }}
                  >
                    <div className="voucher-req-row-1">
                      <Controller
                        name={`vouchers.[${index}].customer_type`}
                        control={control}
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => {
                          console.log(
                            "FIELD CHNAGE",
                            selectedFormIndex == index,
                            errors
                          );
                          return (
                            <div>
                              <SelectDropdown
                                disabled={vouchers[selectedItem]?.isDisabled}
                                label="This voucher can be used by"
                                name={field.name}
                                placeholder="Select a voucher..."
                                errors={
                                  errors?.vouchers?.[index]?.customer_type
                                    ? "error"
                                    : null
                                }
                                options={customerOptions}
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                className="w-full md:w-[265px]"
                                register={register}
                              />
                            </div>
                          );
                        }}
                      />
                      <Controller
                        name={`vouchers.[${index}].max_redemption`}
                        control={control}
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => (
                          <TextInput
                            label="Maximum redemption"
                            disabled={vouchers[selectedItem]?.isDisabled}
                            type="text"
                            name={field.name}
                            placeholder="10"
                            error={
                              errors?.vouchers?.[index]?.max_redemption
                                ? "error"
                                : null
                            }
                            onChange={(e) => field.onChange(e.target.value)}
                            value={field.value}
                            register={register}
                            className="w-full md:w-[150px]"
                          />
                        )}
                      />
                      <Controller
                        name={`vouchers.[${index}].redemption_rule`}
                        control={control}
                        defaultValue=""
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => {
                          return (
                            <div>
                              <SelectDropdown
                                label="Redemptions rule"
                                disabled={vouchers[selectedItem]?.isDisabled}
                                name={field.name}
                                placeholder="Select a rule..."
                                errors={
                                  errors?.vouchers?.[index]?.redemption_rule
                                    ? "error"
                                    : null
                                }
                                options={RedemptionsRule}
                                onChange={(e) => field.onChange(e.target.value)}
                                register={register}
                                value={field.value}
                                className="w-full md:w-[265px]"
                              />
                              {errors?.redemptions_rule && (
                                <p className="error">
                                  {errors.redemptions_rule.message}
                                </p>
                              )}
                            </div>
                          );
                        }}
                      />
                    </div>
                    <div className="voucher-req-row-2">
                      <div className="voucher-quantity-block">
                        <label>Total voucher quantity</label>
                        <div className="voucher-quantity-list">
                          <RadioInput
                            name="options"
                            value="0"
                            checked={
                              selectedOption[selectedItem]?.voucher_qty_type ==
                              "0"
                            }
                            onChange={(e) => {
                              setValue(
                                `vouchers.[${index}].voucher_qty_type`,
                                e.target.value
                              );
                              setValue(`vouchers.[${index}].qty`, "");
                              handleOptionChange(selectedItem, e);
                            }}
                            label="Unlimited"
                            className="!mb-0"
                          />
                          <div className="voucher-quantity">
                            <RadioInput
                              name="options"
                              value="1"
                              checked={
                                selectedOption[selectedItem]
                                  ?.voucher_qty_type == "1"
                              }
                              onChange={(e) => {
                                setValue(
                                  `vouchers.[${index}].voucher_qty_type`,
                                  e.target.value
                                );
                                handleOptionChange(selectedItem, e);
                              }}
                              label="Set Quantity"
                              className="!mb-0"
                            />
                            {console.log("ERRORS", errors?.vouchers)}

                            {watch(`vouchers.[${index}].voucher_qty_type`) == 1 && (
                              <Controller
                                name={`vouchers.[${index}].qty`}
                                control={control}
                                rules={{
                                  required:
                                    selectedOption[selectedItem]
                                      ?.voucher_qty_type == "1",
                                }}
                                render={({ field }) => (
                                  <TextInput
                                    type="text"
                                    name={field.name}
                                    error={
                                      errors?.vouchers?.[index]?.qty
                                        ? "error"
                                        : null
                                    }
                                    placeholder="1000"
                                    onChange={(e) =>
                                      field.onChange(e.target.value)
                                    }
                                    value={field.value}
                                    register={register}
                                    className="w-[107px] !mb-0"
                                    disabled={
                                      selectedOption[selectedItem]
                                        ?.voucher_qty_type !== "1"
                                    }
                                  />
                                )}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <Controller
                        control={control}
                        name={`vouchers.[${index}].start_period`}
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => {
                          return (
                            <div className="input-group">
                              <label>Start Date</label>
                              <DatePicker
                                placeholder="DD-MM-YYYY"
                                disabled={vouchers[selectedItem]?.isDisabled}
                                status={
                                  errors?.vouchers?.[index]?.start_period
                                    ? "error"
                                    : null
                                }
                                name={field.name}
                                ref={field.ref}
                                format={"DD-MM-YYYY"}
                                className={`py-[8px] md:max-w-[190px]`}
                                value={
                                  field.value !== ""
                                    ? !isNaN(field.value)
                                      ? dayjs(field.value)
                                      : dayjs(field.value, "DD-MM-YYYY")
                                    : null
                                }
                                onChange={(date) => {
                                  field.onChange(
                                    date !== null ? date.valueOf() : ""
                                  );
                                  setValue(`vouchers.[${index}].end_period`, "")
                                }}
                                disabledDate={(current) => {
                                  return moment().add(-1, 'days') >= current;
                                }}
                              />
                            </div>
                          );
                        }}
                      />
                      <Controller
                        control={control}
                        name={`vouchers.[${index}].end_period`}
                        defaultValue=""
                        rules={{
                          required: false,
                        }}
                        render={({ field }) => {
                          console.log("END DATE ICKER", !isNaN(field.value));

                          return (
                            <div className="input-group">
                              <label>End Date</label>
                              <DatePicker
                                placeholder="DD-MM-YYYY"
                                disabled={vouchers[selectedItem]?.isDisabled}
                                status={
                                  errors?.vouchers?.[index]?.end_period
                                    ? "error"
                                    : null
                                }
                                name={field.name}
                                ref={field.ref}
                                format={"DD-MM-YYYY"}
                                className={`py-[8px] md:max-w-[190px]`}
                                value={
                                  field.value !== ""
                                    ? !isNaN(field.value)
                                      ? dayjs(field.value)
                                      : dayjs(field.value, "DD-MM-YYYY")
                                    : null
                                }
                                onChange={(date) => {
                                  console.log("DATE ONCHANGE", date);
                                  field.onChange(
                                    date !== null ? date.valueOf() : ""
                                  );
                                }}
                                disabledDate={(d) =>
                                  d.isBefore(dayjs(watch(`vouchers.[${index}].start_period`)))
                                }
                              />
                            </div>
                          );
                        }}
                      />
                      <Controller
                        control={control}
                        name={`vouchers.[${index}].amount_from`}
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => {
                          return (
                            <div className="input-group">
                              <label>Eligible floor amount from</label>
                              <InputNumber
                                type="number"
                                prefix="$"
                                min={0}
                                disabled={vouchers[selectedItem]?.isDisabled}
                                name={field.name}
                                ref={field.ref}
                                value={field.value}
                                status={
                                  errors?.vouchers?.[index]?.amount_from
                                    ? "error"
                                    : null
                                }
                                prefixCls="sign_Icon"
                                placeholder="0.00"
                                precision={2}
                                step="0.01"
                                className="!w-full cusAdmInputNumber2"
                                onChange={(val) => field.onChange(val)}
                              />
                              {errors?.eligible_from && (
                                <p className="error">
                                  {errors.eligible_from.message}
                                </p>
                              )}
                            </div>
                          );
                        }}
                      />
                      <Controller
                        control={control}
                        name={`vouchers.[${index}].amount_to`}
                        rules={{
                          required:
                            selectedFormIndex == index &&
                            !vouchers[selectedItem]?.isDisabled,
                        }}
                        render={({ field }) => {
                          return (
                            <div className="input-group">
                              <label>Eligible floor amount to</label>
                              <InputNumber
                                type="number"
                                min={0}
                                disabled={vouchers[selectedItem]?.isDisabled}
                                prefix="$"
                                name={field.name}
                                ref={field.ref}
                                value={field.value}
                                status={
                                  errors?.vouchers?.[index]?.amount_from
                                    ? "error"
                                    : null
                                }
                                prefixCls="sign_Icon"
                                placeholder="0.00"
                                precision={2}
                                step="0.01"
                                className="!w-full cusAdmInputNumber2"
                                onChange={(val) => field.onChange(val)}
                              />
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                )
            )}
            <div className="text-right">
              <Button type="submit" className="sav_btn" disabled={vouchers[selectedItem]?.isDisabled}>
                {isEdit?.edit ? "Update" : "Save"}
              </Button>
            </div>
          </form>
        </FormProvider>
        <div className="voucher-preview">
          <div className="hr-line-menu">
            <div className="clear-block">
              <h2>Voucher Preview</h2>
            </div>
          </div>
          <p>
            This is dealers will see the vouchers for flooring application in
            each vehicle type. Voucher quantity are counted together for all
            vehicle types.
          </p>
          {isEdit?.edit ? (
            <div className="voucher-preview-section create-voucher">
              {isEdit?.item === "COE" && flooringRateStatus?.COE && (
                <VoucherCard
                  voucher={watch(`vouchers.[${0}]`)}
                  customerOptions={customerOptions}
                  RedemptionsRule={RedemptionsRule}
                  vouchers={vouchers}
                  type={isEdit?.type !== "" ? isEdit?.type : undefined}
                />
              )}
              {isEdit?.item === "PARF" && flooringRateStatus?.PARF && (
                <VoucherCard
                  voucher={watch(`vouchers.[${1}]`)}
                  customerOptions={customerOptions}
                  RedemptionsRule={RedemptionsRule}
                  vouchers={vouchers}
                  type={isEdit?.type !== "" ? isEdit?.type : undefined}
                />
              )}
              {isEdit?.item === "BODYONLY" && flooringRateStatus?.BODYONLY && (
                <VoucherCard
                  voucher={watch(`vouchers.[${2}]`)}
                  customerOptions={customerOptions}
                  RedemptionsRule={RedemptionsRule}
                  vouchers={vouchers}
                  type={isEdit?.type !== "" ? isEdit?.type : undefined}
                />
              )}
            </div>
          ) : (
            <div className="voucher-preview-section create-voucher">
              {console.log("FORM IS EDIT", isEdit)}
              <CustomSlider>
                {flooringRateStatus?.COE && (
                  <VoucherCard
                    voucher={watch(`vouchers.[${0}]`)}
                    customerOptions={customerOptions}
                    RedemptionsRule={RedemptionsRule}
                    vouchers={vouchers}
                  />
                )}
                {flooringRateStatus?.PARF && (

                  <VoucherCard
                    voucher={watch(`vouchers.[${1}]`)}
                    customerOptions={customerOptions}
                    RedemptionsRule={RedemptionsRule}
                    vouchers={vouchers}
                  />
                )}
                {flooringRateStatus?.BODYONLY && (

                  <VoucherCard
                    voucher={watch(`vouchers.[${2}]`)}
                    customerOptions={customerOptions}
                    RedemptionsRule={RedemptionsRule}
                    vouchers={vouchers}
                  />
                )}
              </CustomSlider>
            </div>
          )}

        </div>
      </>
    )
  );
};
export default FlooringVoucherFormModal;
